// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMediaAudioMuteSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.124 14.74c.384-.78.626-1.709.626-2.74 0-1.57-.56-2.902-1.329-3.836-.613-.743-1.314-1.187-1.927-1.347-.267-.069-.494-.29-.494-.567v-.5c0-.276.225-.503.498-.462 1.13.17 2.24.902 3.08 1.923.982 1.192 1.672 2.859 1.672 4.79a7.65 7.65 0 0 1-1.018 3.847zm.111 2.435 1.942 1.941a.5.5 0 0 1 0 .707l-.354.354a.5.5 0 0 1-.707 0l-2.054-2.054c-.5.303-1.03.509-1.564.59-.273.04-.498-.187-.498-.463v-.5c0-.276.227-.498.494-.567.15-.039.304-.094.46-.167L14 14.06V19c0 .866-1.026 1.323-1.669.743L8.59 16.14a.5.5 0 0 0-.347-.14H4.5a.5.5 0 0 1-.5-.5v-7a.5.5 0 0 1 .5-.5h3.44L3.822 3.884a.5.5 0 0 1 0-.707l.354-.354a.5.5 0 0 1 .707 0l4.411 4.412.001-.001L14 11.937v.003l2 2v-.003l.79.79-.002.001 1.387 1.386 1.061 1.06zM12.331 4.257C12.974 3.677 14 4.134 14 5v4.616l-3.532-3.532zM16 9.5c0-.276.231-.504.486-.397C17.3 9.447 18 10.614 18 12c0 .496-.09.963-.241 1.375L16 11.616z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgMediaAudioMuteSolid;
